import uriTools from './uri-tools';
import emailVerification from './email-verification';
import flashMessage from './flash-message';
import domainCheck from './domain-check';
import multiStepForm from './multi-step-form';
import _t from './backend-translation-handler';

class SignupEvents {

    registerResendEmailVerificationHandler(btnElementId, backupEmailInputId, type) {
        const btnEl = document.getElementById(btnElementId);
        const backupEmailInputEl = document.getElementById(backupEmailInputId);

        btnEl.onclick = (e) => {
            e.preventDefault();

            const emailVerificationInstance = new emailVerification(backupEmailInputEl.value, type);
            btnEl.disabled = true;
            emailVerificationInstance.sendConfirmationCode(function (sent) {
                const flashMessageInstance = new flashMessage('alert-message-container');
                if (sent) {
                    emailVerification.prototype.alreadySent[backupEmailInputEl.value] = true;
                    flashMessageInstance.add('info', _t('verification.info'));
                } else {
                    flashMessageInstance.add('error', _t('verification.error'));
                }
                return sent;
            }, true);
        }
    }

    initializeTabFieldsActions() {
        // If you come not from "data-next_tab" links you should update validatable fields:
        $(window).on('switchToTabEvent', () => {
            // Update validator on tab switch
            const $signupBusinessForm = $('#signup-business');
            if ($signupBusinessForm) {
                $signupBusinessForm.validator('update');
            }

            const $signupPersonalForm = $('#signup-personal');
            if ($signupPersonalForm) {
                $signupPersonalForm.validator('update');
            }
        });
    }

    formPagesReloadHandler() {
        // FYI. This happens only once, when page is initialized, reloaded or navigated to. Not happening on tab switching.
        const initialFormTabIds = ['signup_business_start', 'signup_personal_start'];
        initialFormTabIds.forEach(formTabId => {
            if ($('#' + formTabId).length === 0) {
                return;
            }

            //facebook adds _=_ hash
            const socialConnect = ['signup_personal_social_connected', 'signup_business_social_connected', '_=_'];

            const hash = window.location.hash.substr(1);
            if (document.getElementById(formTabId) && (hash !== formTabId && socialConnect.indexOf(hash) === -1)) {
                document.querySelector('.signup-wrapper form').reset();
                multiStepForm.switchToTab(formTabId);
            }

            //facebook overrides hash :/
            const queryData = uriTools.deserializeQueryStringToObject();
            if (hash === '_=_' || socialConnect.indexOf(hash) > -1 || queryData.resourceOwner) {
                const formToTabMapping = {
                    'signup_business_start': 'signup_business_social_connected',
                    'signup_personal_start': 'signup_personal_social_connected'
                };

                //after failed business social login in signup we override to first signup tab as we don't know domain
                //of social button clicked from signup there will always be domainName passed
                if ($('#signup_business_start').length > 0 && !queryData['domainName']) {
                    multiStepForm.switchToTab('signup_business_start');
                } else {
                    multiStepForm.switchToTab(formToTabMapping[formTabId]);
                }
            }
        });
    }
}

export default SignupEvents;
